import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-actividades',
  templateUrl: './list-actividades.component.html',
  styleUrls: []
})
export class ListActividadesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
